<template>
  <v-toolbar
    v-show="$route.path === '/tv' ? false : true"
    :color="color"
    flat
    app
    :tabs="tabs ? true : false"
    :class="`${className} ${hasTabs ? 'has-tabs' : ''}`"
    class="c navigation"
    :dark="color !== 'white'"
  >
    <v-btn
      v-if="$route.path !== '/' && $route.path !== '/events' && $route.path !== '/statistics'"
      :to="backUrl"
      flat
      icon
    >
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <img src="../../assets/logo.png" class="logo">
    <v-toolbar-title>
      <span>{{ navTitle }}</span>
    </v-toolbar-title>
    <v-spacer />
    <v-btn
      v-for="element in rightElements"
      :key="element.label"
      :flat="element.flat"
      :icon="element.icon.show"
      :to="element.to"
      :color="element.color"
    >
      <v-icon v-if="element.icon.name">{{ element.icon.name }}</v-icon>
      <span>{{ element.label || '' }}</span>
    </v-btn>
    <v-tabs
      v-if="tabs"
      slot="extension"
      slider-color="primary"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.label"
        :to="tab.to"
      >
        {{ tab.label }}
      </v-tab>
    </v-tabs>
  </v-toolbar>
</template>

<script>
export default {
  name: 'Navigation',

  data() {
    return {
      hasTabs: false,
    };
  },

  computed: {
    navTitle() {
      return this.$store.state.navigation.title;
    },
    lastUrl() {
      return this.$store.state.last_url;
    },
    backUrl() {
      return this.$store.state.navigation.backUrl;
    },
    rightElements() {
      return this.$store.state.navigation.rightElements;
    },
    tabs() {
      return this.$store.state.navigation.tabs;
    },
    className() {
      return this.$store.state.navigation.class;
    },
    color() {
      return this.$store.state.navigation.color;
    },
  },

  watch: {
    tabs: {
      immediate: true,
      handler(newVal) {
        if (newVal !== null) {
          this.hasTabs = true;
        } else {
          this.hasTabs = false;
        }
      },
    },
  },
};
</script>
